import { FC, useEffect, useState } from "react";

interface LineBarProps {
  /**
   * The value of the line bar.
   */
  value: number;
}
export const LineBar: FC<LineBarProps> = ({ value }) => {
  // Initialize state with 0
  const [stateValue, setStateValue] = useState(0);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    setPrefersReducedMotion(
      !!window.matchMedia("(prefers-reduced-motion: reduce)"),
    );
  }, []);

  // Update state with actual value from props after initial render
  useEffect(() => {
    setTimeout(() => {
      setStateValue(value);
    }, 0);
  }, [value]);

  return (
    <div
      aria-hidden="true"
      className="relative h-6 w-full rounded-DEFAULT border border-darkestBlue/40 bg-[#e0e0e0] dark:border-lightblue/30 dark:bg-[#e0e0e0]/40"
    >
      <div
        className="absolute left-0 top-0 h-full rounded-DEFAULT bg-green transition-width duration-1000 reduce-motion:transition-none forced-colors:bg-[CanvasText]"
        style={{ width: `${prefersReducedMotion ? value : stateValue}%` }}
      />
      <div
        className="absolute top-1/2 flex aspect-square min-h-[3rem] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-darkestBlue drop-shadow transition-[left] duration-1000 reduce-motion:transition dark:border-2 dark:border-lightblue dark:bg-slate-900 lg:min-h-[5rem] lg:min-w-[5rem]"
        style={{ left: `${prefersReducedMotion ? value : stateValue}%` }}
      >
        <span className=" p-4 text-lg font-semibold text-white">{`${value} %`}</span>
      </div>
    </div>
  );
};

export default LineBar;
